module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"new":"Detailsuche","cancel":"Abbrechen","artikelNummer":"Artikelnummer","artikelBezeichnung":"Artikelbezeichnung","verkaufsPreisExklUst":"Verkaufspreis Netto"},"en":{"new":"Detailsearch","cancel":"Cancel","artikelNummer":"Artikelnummer","artikelBezeichnung":"Artikelbezeichnung","verkaufsPreisExklUst":"Verkaufspreis Netto"}}')
  delete Component.options._Ctor
}
